module.exports = __webpack_public_path__ + "img/admin-F.9661da3d.png";